import _ from 'lodash'
import brush from 'brush'
import {isBlank} from 'oderon-commons/src/utils'
import VehicleCfgs from 'vehicle-cfgs'

// Garante que todos os valores são strings, começam
// com 0x, e possuem número par de caracteres.
// export function ensureHex(values) {
//   _.forOwn(values, (v, k) => {
//     v = v.toString().trim().replace(/^0x/, '')
//     if ( v.length % 2 != 0 ) v = '0' + v
//     values[k] = '0x' + v
//   })
//
//   return values
// }

// Garante que um valor é string, começa
// com 0x, e possui número par de caracteres.
export function toHex(value) {
  if ( value == null ) return null
  if ( _.isNumber(value) ) value = value.toString(16)
  value = value.trim().replace(/^0x/, '')
  if ( value.length % 2 != 0 ) value = '0' + value
  return '0x' + value
}

export function hexToAscii(val) {
  if ( val == null || val.trim().length < 1 ) return '-'

  let bytes = brush.hexToBytes(val),
      res = ''
  for ( let b of bytes ) {
    if ( b == 0 ) break
    res += String.fromCharCode(b)
  }

  return res
}

export function formatValue(value, configDef) {
  if ( isBlank(value) ) return '-'

  if ( configDef.type == 'number' ) {
    let h = toHex(value),
        d = parseInt(h, 16)
    return `${h} (${d})`
  }

  else if ( configDef.type == 'select' ) {
    let opt = _.find(configDef.opts, {value})
    if ( opt ) return opt.label
    else return 'Unknown opt value: ' + value
  }

  // Aqui, é uma string. Se for embeddable, é
  // null-terminated; traduz o 0x... para ascii.
  else if ( configDef.isEmbeddable ) {
    return hexToAscii(value)
  }

  // Aqui, é uma string não-embeddable, então
  // apenas mostra como estiver.
  else {
    return value
  }
}

export function formatAnalogic(anNumber, configsObj) {
  const code = `valor-an-${anNumber}`
  const anValue = configsObj[code]
  const anOpts = VehicleCfgs.get(code, 'opts')
  const optStr = anOpts.find(x => x.value == anValue).label

  // Aqui não precisamos ir nas opts porque todas as opts
  // possuem o value igual ao label
  const labelCode = `an${anNumber}label`
  const labelStr = configsObj[labelCode] || 'padrão'

  const scaleCode = `an${anNumber}scale`
  const scaleStr = configsObj[scaleCode] || 'padrão'

  return `${optStr} (label ${labelStr}, escala ${scaleStr})`
}